/**
 * Constantes para el Dashboard de Avance de Proyectos
 */

/**
 * Número de elementos por página
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Estados de proyectos disponibles
 */
export const PROJECT_STATUSES = {
  ALL: 'all',
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

/**
 * Opciones para el filtro de estados
 */
export const STATUS_OPTIONS = [
  { value: PROJECT_STATUSES.ALL, label: 'Todos los estados' },
  { value: PROJECT_STATUSES.NOT_STARTED, label: 'Sin empezar' },
  { value: PROJECT_STATUSES.IN_PROGRESS, label: 'En progreso' },
  { value: PROJECT_STATUSES.COMPLETED, label: 'Completado' },
  { value: PROJECT_STATUSES.CANCELLED, label: 'Cancelado' }
];

/**
 * Intervalos de actualización automática en milisegundos
 */
export const REFRESH_INTERVALS = {
  MANUAL: 0,
  FAST: 15000,    // 15 segundos
  MEDIUM: 30000,  // 30 segundos
  SLOW: 60000,    // 1 minuto
  VERY_SLOW: 300000 // 5 minutos
};

/**
 * Opciones para el intervalo de actualización
 */
export const REFRESH_INTERVAL_OPTIONS = [
  { value: REFRESH_INTERVALS.MANUAL, label: 'Manual' },
  { value: REFRESH_INTERVALS.FAST, label: '15 segundos' },
  { value: REFRESH_INTERVALS.MEDIUM, label: '30 segundos' },
  { value: REFRESH_INTERVALS.SLOW, label: '1 minuto' },
  { value: REFRESH_INTERVALS.VERY_SLOW, label: '5 minutos' }
];

/**
 * Estado inicial de los filtros
 */
export const INITIAL_FILTER_STATE = {
  status: PROJECT_STATUSES.ALL,
  subscriber: 'all',
  startDate: '',
  endDate: '',
  search: '',
  sortBy: 'name',
  viewMode: 'cards',
  refreshInterval: REFRESH_INTERVALS.MEDIUM
};

/**
 * Colores para los gráficos por estado
 */
export const STATUS_COLORS = {
  [PROJECT_STATUSES.COMPLETED]: '#4caf50',
  [PROJECT_STATUSES.IN_PROGRESS]: '#2196f3',
  [PROJECT_STATUSES.NOT_STARTED]: '#ff9800',
  [PROJECT_STATUSES.CANCELLED]: '#f44336'
};

/**
 * Etiquetas para los gráficos
 */
export const STATUS_LABELS = {
  [PROJECT_STATUSES.COMPLETED]: 'Completados',
  [PROJECT_STATUSES.IN_PROGRESS]: 'En Progreso',
  [PROJECT_STATUSES.NOT_STARTED]: 'Sin Empezar',
  [PROJECT_STATUSES.CANCELLED]: 'Cancelados'
};
